export default __webpack_public_path__ + "static/mobileImage-c47147a07279ef1f924169536b6bf444.jpg";